import { format } from 'date-fns';

export default function CatalystCard({ catalyst, onClick }) {
  const { id, title, event_date, event_type, region, impact_count, narrative } = catalyst;

  return (
    <article
      onClick={onClick}
      className="group cursor-pointer rounded-xl border border-neutral-200 bg-document p-4 transition hover:border-[#003cc5]/40 hover:shadow-sm animate-fade-in"
    >
      <div className="mb-2 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="mb-0.5 text-xs font-semibold uppercase tracking-wider text-[#003cc5]">
            Event #{id}
          </p>
          <h3 className="text-sm font-semibold leading-snug text-ink line-clamp-2">{title}</h3>
        </div>
        {impact_count > 0 && (
          <span className="shrink-0 rounded-full bg-red-50 px-2 py-0.5 text-xs font-medium text-[#003cc5] border border-red-200">
            {impact_count.toLocaleString()} impacted
          </span>
        )}
      </div>

      {narrative && (
        <p className="mb-3 text-xs leading-relaxed text-neutral-500 line-clamp-2">{narrative}</p>
      )}

      <div className="flex flex-wrap items-center gap-3 text-xs text-neutral-400">
        {region && (
          <span className="flex items-center gap-1">
            <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <circle cx="12" cy="11" r="3" />
            </svg>
            {region}
          </span>
        )}
        {event_type && <span>{event_type}</span>}
        {event_date && <span>{format(new Date(event_date), 'MMM d, yyyy')}</span>}
      </div>
    </article>
  );
}
